import { render } from "./Timer.vue?vue&type=template&id=b70babd8&scoped=true"
import script from "./Timer.vue?vue&type=script&lang=js"
export * from "./Timer.vue?vue&type=script&lang=js"

import "./Timer.vue?vue&type=style&index=0&id=b70babd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70babd8"]])

export default __exports__